/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _humanize = _interopRequireDefault(require("../../../../utils/humanize"));
var _default = function _default(cellProps, column, headerProps, contextMenu) {
  var header = cellProps.header,
    name = cellProps.name;
  if (header !== undefined) {
    if (typeof header !== 'function') {
      return header;
    }
    return header(cellProps, {
      cellProps: cellProps,
      column: column,
      headerProps: headerProps,
      contextMenu: contextMenu
    });
  }
  return (0, _humanize.default)(name || '');
};
exports.default = _default;